import React, { useState, useRef } from "react";
import "./banner.css";
import { connect } from "react-redux";
import Cookies from "universal-cookie";
import { decode } from "base-64";
import axios from "axios";
import API_ENDPOINT from "../wm.api.service";
import ClearIcon from "@material-ui/icons/Clear";
import CircularProgress from "@material-ui/core/CircularProgress";
import VisibilityIcon from '@material-ui/icons/Visibility';
import { getUsersEntireData } from "../functions/apis";
import Tooltip from "@material-ui/core/Tooltip";
// ICONS
import { userBannerPic, setMasterData } from "../services/actions/actions";
import WmModals from "../modals/Wm.Modals";
import Croppers from "../Components/ImageCroppers/Cropper";
import Wmbutton from "../ui-components/wm-button/Wm.button";
// import {} from ""
const cookies = new Cookies();
function Banner({ responsive, rootData, setData }) {
  var token = cookies.get("wmtoken");
  const cropperRef = useRef();
  const coverImage = useRef(null);
  function handleImageClick() {
    coverImage.current.click();
  }
  const [isCropperModal, setIsCropperModal] = useState(false)
  const [fileObject, setFileObject] = useState('')
  function uploadImage(e) {
    const file = e.target.files[0];
    setFileObject(file)
    setIsCropperModal(true)
  }
  const [isUploading, setIsUploading] = useState(false)
  const [isBannerOpen, setIsBannerOpen] = useState(false);
  const openBannerModal = () => {
    setIsBannerOpen(true);
  };
  const uploadImagefileObject = () => {
    cropperRef.current.sendObjectFile()
  }
  const getFile = (file) => {
    uploadPhoto(file)
  }
  const uploadPhoto = (file) => {
    var fd = new FormData();
    if (token) {
      fd.append("token", decode(token));
      fd.append("identity", "wmhandler");
      fd.append("photoType", "banner");
      fd.append("banner", file);
      axios({
        method: "POST",
        url: `${API_ENDPOINT.apiURL}Profile/updateUserPhoto`,
        data: fd,
      })
        .then(function (response) {
          getUsersEntireData(rootData.user.username).then(function (res) {
            setData(res);
            setIsCropperModal(false)
            setIsUploading(false)
            setIsCropperModal(false)
          }).catch(function (err) {
            console.log(err)
          })
        })
        .catch(function (err) {
          console.log(err);
          setIsUploading(false)
        });
    }
  };
  if (cookies.get("wmusers")) {
    var user = decode(cookies.get("wmusers"));
  } else {
    var user = 'members';
  }
  const redirectToUserProfile = () => {
    window.location.assign(`${API_ENDPOINT.redirectURL}/${rootData.username}`)
  }
  return (
    <>
      <div className={`banner h-80 bg-black container-wm relative overflow-hidden ${responsive}`}>
        <div className="banner_outer h-full relative cursor-pointer" onClick={() => openBannerModal()}>
          <img src={rootData.bannerImage} alt="" className="h-full w-full object-cover hasHover-bannerImage cursor-pointer" style={{ objectPosition: "0 15%" }}/>
          <div className="banner-gradient absolute w-full bottom-0 h-1/2"></div>
        </div>
        <div className="flex absolute bottom-3.5 right-8 text-white space-x-4 items-center z-2">
          <input type="file" style={{ display: "none" }} ref={coverImage} onChange={(e) => uploadImage(e)} accept="image/png, image/jpeg, image/jpg"/>
          <button className="bg-white text-gray-700 rounded-full focus:outline-none py-1 px-4 manpro font-medium text-sm" onClick={handleImageClick}>Edit Cover Image</button>
          <Tooltip title="Public Profile" placement="bottom"><VisibilityIcon className="cursor-pointer" onClick={redirectToUserProfile} /></Tooltip>
        </div>
        <WmModals show={isBannerOpen} onHide={() => setIsBannerOpen(false)} size="lg" className="">
          <div className="bannerModal p-2 relative">
            <div className="clearIcon absolute right-3 top-3 rounded-full w-8 h-8 flex items-center justify-center bg-gray-200 cursor-pointer" onClick={() => setIsBannerOpen(false)}>
              <ClearIcon />
            </div>
            <img src={rootData.bannerImage} alt="banner" className="w-full h-80 object-contain" />
          </div>
        </WmModals>
        <WmModals show={isCropperModal} onHide={() => setIsCropperModal(false)} size="lg" className="">
          <div className="bannerModal p-2 relative">
            <div className="clearIcon absolute right-3 top-3 rounded-full z-50 w-8 h-8 flex items-center justify-center bg-gray-200 cursor-pointer" onClick={() => setIsCropperModal(false)}>
              <ClearIcon />
            </div>
            <div className="p-3 relative h-80">
              <Croppers fileObject={fileObject} ref={cropperRef} getFile={(file) => getFile(file)} />
            </div>
            <div className="text-right mt-3">
              <Wmbutton label={isUploading ? <CircularProgress className="loader_size_xsm text-white" /> : "Upload"} onClick={() => { setIsUploading(true); uploadImagefileObject() }} className="rounded w-20 mr-2" type="button" color="primary" />
              <Wmbutton label="Cancel" onClick={() => setIsCropperModal(false)} className="rounded w-20" type="button" color="primary" />
            </div>
          </div>
        </WmModals>
      </div>
    </>
  );
}

const mapStateToProps = (state) => {
  return state;
};

const mapDispatchToState = (dispatch) => {
  return {
    userBannerPics: (value) => {
      dispatch(userBannerPic(value));
    },
    setData: (value) => {
      dispatch(setMasterData(value));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToState)(Banner);
